import React from 'react';

export const TDHOutlineLogo = (props: any) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" width="535.505" height="535.508" viewBox="0 0 535.505 535.508">
    <g id="Group_76" data-name="Group 76" transform="translate(-165.246 -3828.742)">
      <path
        id="Path_23"
        data-name="Path 23"
        d="M433,3829.742a73.53,73.53,0,0,1,0,127.438,139.318,139.318,0,0,1,0,278.636,73.517,73.517,0,0,0,0,127.431c147.319,0,266.749-119.43,266.749-266.749S580.321,3829.742,433,3829.742"
        fill="none"
        stroke="#fff"
        strokeMiterlimit="10"
        strokeWidth="2"
      />
      <path
        id="Path_24"
        data-name="Path 24"
        d="M433,4363.25a73.523,73.523,0,0,1,0-127.438,139.314,139.314,0,1,1,0-278.629,73.53,73.53,0,0,0,0-127.438c-147.326,0-266.756,119.43-266.756,266.756S285.676,4363.25,433,4363.25"
        fill="none"
        stroke="#fff"
        strokeMiterlimit="10"
        strokeWidth="2"
      />
    </g>
  </svg>
);
